import { casesStatusUpdateApi, DEFAULTAVATAR, getTeamupListApi, raiseNotificationApi, removeInviteApi, updateInviteStatusApi } from 'Constants';
import React, { useEffect, useState, useContext } from 'react';
import { Context } from 'Context/Context';
import TableElements from 'Components/Professional/Cases/TableElements';
import PaginateBtns from 'Components/Admin/PaginateBtns';
import RequestToViewBtn from 'Components/Professional/Cases/RequestToViewBtn';
import ViewFullCaseDetailsBtn from 'Components/Professional/Cases/ViewFullCaseDetailsBtn';
import SeeIfConflictBtn from 'Components/Professional/Cases/SeeIfConflictBtn';
import { getCaseType, getStringFromNumber } from 'Utils';
import ProfessionalsInvolved from 'Components/Professional/Cases/ProfessionalsInvolved';
import TestModal from 'Modals/TestModal';
import ApprovedCases from 'Components/Professional/Cases/ApprovedCases';
import NoConflictCases from 'Components/Professional/Cases/NoConflictCases';
import AllCases from 'Components/Professional/Cases/AllCases';
import RequestedCases from 'Components/Professional/Cases/RequestedCases';
import ReqToCloseCases from 'Components/Professional/Cases/ReqToCloseCases';
import ClosedCases from 'Components/Professional/Cases/ClosedCases';
import moment from 'moment';
import TeamUpDetailsModalContent from 'Modals/TeamUpDetailsModalContent';
import { CiUser } from 'react-icons/ci';
import { FaSackDollar, FaUser } from 'react-icons/fa6';
import { EmptyState, CardSkeleton, HEADER_H } from 'Components/Professional/Cases/CaseListUI';
import { Avatar, TuPill } from 'Components/Professional/Cases/TeamupUI';

import { useNavigate } from 'react-router-dom';
import TeamupCollaboratedCount from './TeamupCollaboratedCount';
import AttorneyDashboardInfo from './AttorneyDashboardInfo';
import TeamupDashboardMobileModal from 'Modals/TeamupDashboardMobileModal';
import useIsMobile from 'Hooks/useIsMobile';

const chip = 'font-plexsans font-medium text-[11.5px] leading-none text-navy bg-[rgba(20,33,61,.05)] border border-[rgba(20,33,61,.12)] rounded-[5px] px-2 py-[5px] whitespace-nowrap';

function AttorneyDashboardTeamup({userInfo, attorney, offset, setOffset, updateComp, setUpdateComp, isConnectedList = false, innerPanel}) {
    const {makeApiCallFunc, userDetails, filters, setFilters, reqRevCountArr, setReqRevCountArr, setSelectedMenuItem} = useContext(Context);
    const navigate = useNavigate();
    const [skip, setSkip] = useState(0);
    const isMobile = useIsMobile();
    const [casesList, setCasesList] = useState(null);
    const [selected, setSelected] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [limit, setLimit] = useState(5);
    const [isResponseReceived, setIsResponseReceived] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [showEachCase, setShowEachCase] = useState(false);
    const [singleCase, setSingleCase] = useState(null);
    const [showHoverMsg, setShowHoverMsg] = useState(false);
    const [showCollaboratedHoverMsg, setShowCollaboratedHoverMsg] = useState(false);
    const hoverMessage = "You can collaborate with attorney after you have access to complete case details. You can get started with clicking Request button below.";
 
 const processReqReviewCount = (data) => {
        let idWithReqReviewArr = null;
        if(data?.length !== 0 )
            {
                idWithReqReviewArr = {}
                data?.map((item) => {
                       // let incrCounter = item.deniedCount !== 0 ? (item.caseStatus === "denied" ? item.deniedCount : parseInt(item.deniedCount) + 1 ) : 1;
                      let incrCounter =  1 ;
                       let statusVariable =  (item.caseStatus === "denied" && item.userId !== userInfo._id) ? "requested" : item.caseStatus;
                        if(idWithReqReviewArr[item.caseId])
                        {   
                            if(idWithReqReviewArr[item.caseId][statusVariable])
                            {
                                idWithReqReviewArr[item.caseId][statusVariable] = item.caseStatus === "denied" ? item.deniedCount : idWithReqReviewArr[item.caseId][statusVariable] + incrCounter; 
                            }
                            else
                            {
                                idWithReqReviewArr[item.caseId][statusVariable] = item.caseStatus === "denied" ? item.deniedCount : incrCounter;
                            }
                        }
                        else
                        {
                            
                            idWithReqReviewArr[item.caseId] = { [statusVariable] : item.caseStatus === "denied" ? item.deniedCount : incrCounter}
                        }
                        
                })  
            }

                console.log(idWithReqReviewArr)
                return idWithReqReviewArr;

    }
    useEffect(() => {
        setIsResponseReceived(false);
        makeApiCallFunc(
            getTeamupListApi,
            {
                userId : userInfo?._id,
                isFunder: userInfo?.isUserFunder, 
                skip,  
                limit,
                filters,
                inviteStatus: isConnectedList ? 1 : 0
            },
            ({data}) => {
                setIsResponseReceived(true);
                setCasesList(data.data);
                setTotalCount(data.totalCount);
                setReqRevCountArr(processReqReviewCount(data.userCaseStatusCount));
                setSelected(data.data[0]);
                console.log("Teamup List ", data);
            },
            (err) => {
                setIsResponseReceived(true);
                console.log("Teamup List Error:", err);
            }
        );
    }, [updateComp, skip, innerPanel]);
   
    const cardBuilder = (caseItem) => {
            switch (caseItem?.caseStatus)
            {
                case "approved":
                return <ApprovedCases attorney={attorney} setUpdateComp={setUpdateComp}  cases={[{
                    caseDetails: caseItem.caseDetails,
                    ...caseItem.userCase
                }]} 
                />
                case "noConflict":
                return <NoConflictCases attorney={attorney} 
                isTeamupList={true}
                setUpdateComp={setUpdateComp}  cases={[
                    {
                        caseDetails: caseItem.caseDetails,
                        ...caseItem.userCase
                    }
                ]}
                />
                case null:
                return <AllCases attorney={attorney} cases={[caseItem.caseDetails]} setUpdateComp={setUpdateComp}/>
                case "requested":
                return <RequestedCases attorney={attorney} 
                setUpdateComp={setUpdateComp}
                cases={[{
                    caseDetails: caseItem.caseDetails,
                    ...caseItem.userCase
                }]}  />
                case "reqToClose":
                return <ReqToCloseCases attorney={attorney}
                setUpdateComp={setUpdateComp}
                 cases={[{
                    caseDetails: caseItem.caseDetails,
                    ...caseItem.userCase
                }]} 
                />
                case "closed":
                return <ClosedCases attorney={attorney}
                setUpdateComp={setUpdateComp}
                 cases={[{
                    caseDetails: caseItem.caseDetails,
                    ...caseItem.userCase
                }]} 
                />
                default:
                <>none</>
            }
        }
const deleteTeamup = (removeInviteId, fromUser) => {
            console.log('Deleting teamup');
            setShowModal(false);
            makeApiCallFunc(removeInviteApi, { inviteId: removeInviteId },
            (response) => {
                console.log('Teamup deleted successfully:', response.data);
                const notificationObj = {
                    title : "Team up Withdrawn",
                    is_read : false,
                    sender: "",
                    type: "1",
                    notificationCategory: 1,
                    receiver: fromUser, 
                    additionalInfo: {
                        caseId: selected?.caseDetails?._id
                    },
                    content: 
                    `The team up for case ${selected?.caseDetails?.caseNumber} with ${userInfo?.firstName} ${userInfo?.lastName} has been withdrawn by the funder.`
                    }
                    makeApiCallFunc(raiseNotificationApi, notificationObj,
                    (response) => {
                        console.log('Notification raised successfully:', response.data);
                    },
                    (error) => {
                        console.log('Error raising notification:', error);
                    },
                    null,
                    true,
                    false
                    )
                setUpdateComp((prev) => !prev);
            },
            (error) => {
                console.error('Error deleting teamup:', error);
            }
            );
        }
        const confirmTeamup = (inviteId, fromUser) => {
            // Implement ignore request functionality here
            setShowModal(false);

            makeApiCallFunc(updateInviteStatusApi,
                {
                    inviteId: inviteId,
                    newStatus: 1 // Assuming 1 represents 'confirmed' status
                },
                (response) => {
                    console.log('Invite confirmed successfully:', response.data);
                    // Optionally, update the local state to remove the confirmed invite
                    setUpdateComp((prev) => !prev);
                },
                (error) => {
                    console.log('Error confirming invite:', error);
                },
                null,
                true,
                false
            );
                const notificationObj = {
                        title : "Contact Request Accepted",
                        is_read : false,
                        sender: "",
                        type: "1",
                        notificationCategory: 1,
                        receiver: fromUser,
                        additionalInfo: {
                            caseId: selected?.caseDetails?._id
                        },
                        content: 
                        `The request to connect for case ${selected?.caseDetails?.caseNumber} has been accepted by ${userInfo?.firstName} ${userInfo?.lastName}.`
                        }
                        makeApiCallFunc(raiseNotificationApi, notificationObj,
                        (response) => {
                            console.log('Notification raised successfully:', response.data);
                        },
                        (error) => {
                            console.log('Error raising notification:', error);
                        },
                        null,
                        true,
                        false
                        )
            console.log('Ignore request for invite ID:', inviteId);
        }
  return (
    <>
    {
        showModal && isMobile &&
        <TeamupDashboardMobileModal
        onClose={()=>setShowModal(false)}
        uploadNew={showModal}
        userInfo={userInfo}
        selected={selected}
        cardBuilder={cardBuilder}
        confirmTeamup={confirmTeamup}
        deleteTeamup={deleteTeamup}
        showHoverMsg={showHoverMsg}
        setShowHoverMsg={setShowHoverMsg}
        hoverMessage={hoverMessage}
        />
    }
    {!isResponseReceived && <CardSkeleton count={2}/>}
    { casesList &&
        (
        casesList.length === 0 && isResponseReceived ?
        <EmptyState
            title={isConnectedList
                ? (userInfo?.isUserFunder ? 'No attorney connections yet' : 'No funder connections yet')
                : (userInfo?.isUserFunder ? 'No attorney requests yet' : 'No connection requests yet')}
            body={isConnectedList
                ? (userInfo?.isUserFunder ? 'Attorneys you connect with will show here.' : 'Funders you connect with will show here.')
                : (userInfo?.isUserFunder ? 'Attorneys who want to team up on a case will show here.' : 'Connect with funders from your My cases list.')}
            linkText={!isConnectedList && !userInfo?.isUserFunder && !attorney ? 'Go to My cases' : null}
            onLink={() => { setSelectedMenuItem('2'); setOffset && setOffset(0); navigate('/attorney/casesFeed/activeCases'); }}
        />
        :
        isResponseReceived &&
    <div className={`font-plexsans grid gap-5 items-start ${isMobile ? 'grid-cols-[minmax(0,1fr)]' : 'grid-cols-[minmax(280px,340px)_minmax(0,1fr)]'}`}>
    <div className='flex flex-col gap-2.5 min-w-0'>
        {casesList.map((caseItem, index) => {
            const other = userInfo?.isUserFunder ? caseItem?.fromUser : caseItem?.toUser;
            const sel = !isMobile && selected?._id === caseItem?._id;
            const pending = caseItem?.inviteStatus === 0;
            const name = other?.isUserFunder ? (other?.company || `${other?.firstName || ''} ${other?.lastName || ''}`) : `${other?.firstName || ''} ${other?.lastName || ''}`;
            const sub = other?.isUserFunder ? `${other?.firstName || ''} ${other?.lastName || ''}` : other?.company;
            return (
                <div
                    key={caseItem?._id || index}
                    onClick={() => { setSelected(caseItem); setShowModal(true); }}
                    className={`bg-white border rounded-md py-3.5 px-4 cursor-pointer flex flex-col gap-2.5 transition-[border-color] duration-150 ${sel ? 'border-brass/[.45] shadow-[inset_3px_0_0_#8a6231]' : 'border-navy/[.12] shadow-none hover:border-brass/[.4]'}`}
                >
                    <div className='flex items-center gap-3'>
                        <Avatar user={other} size={38} />
                        <div className='flex flex-col gap-[3px] min-w-0 flex-1'>
                            <span className='font-plexsans font-semibold text-[14px] leading-[1.3] text-navy overflow-hidden text-ellipsis whitespace-nowrap'>{name}</span>
                            {sub && <span className='font-plexsans font-normal text-[12.5px] leading-[1.3] text-navy/[.55] overflow-hidden text-ellipsis whitespace-nowrap'>{sub}</span>}
                        </div>
                        {pending ? <TuPill>Pending</TuPill> : <TuPill tone="green">Connected</TuPill>}
                    </div>
                    <div className='flex flex-wrap gap-1.5'>
                        {caseItem?.caseDetails?.caseNumber && <span className={chip}>{caseItem.caseDetails.caseNumber}</span>}
                        <span className={chip}>{getCaseType(caseItem?.caseDetails?.caseType)}</span>
                        {caseItem?.caseDetails?.caseState && <span className={chip + ' capitalize'}>{caseItem.caseDetails.caseState}</span>}
                    </div>
                    <TeamupCollaboratedCount caseItem={caseItem} userInfo={userInfo} />
                    <span className='font-plexsans font-normal text-[12px] leading-none text-navy/[.5]'>{pending ? 'Requested' : 'Connected'} {moment(caseItem?.updatedAt || caseItem?.createdAt).format("MMM DD, YYYY")}</span>
                </div>
            );
        })}
        <PaginateBtns skip = {skip}
                setSkip={setSkip}
                limit={limit}
                setLimit={setLimit}
                totalCount={totalCount}
            />
    </div>
    {!isMobile &&
    <div style={{ top: (HEADER_H + 16) + 'px', maxHeight: `calc(100vh - ${HEADER_H + 32}px)` }} className='sticky overflow-y-auto min-w-0 hide-vertical-scrollbar'>
      {selected &&
      <AttorneyDashboardInfo
        userInfo={userInfo}
        selected={selected}
        cardBuilder={cardBuilder}
        confirmTeamup={confirmTeamup}
        deleteTeamup={deleteTeamup}
        showHoverMsg={showHoverMsg}
        setShowHoverMsg={setShowHoverMsg}
        hoverMessage={hoverMessage}
        />}
    </div>
    }
    </div>)
    }</>
  )
}

export default AttorneyDashboardTeamup
